import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface DonutStatDatum {
  name: string;
  value: number;
  color: string;
}

interface DonutStatProps {
  data: DonutStatDatum[];
  totalLabel: string;
  totalValue: string;
  height?: number;
  valueFormatter?: (value: number) => string;
}

export default function DonutStat({ data, totalLabel, totalValue, height = 240, valueFormatter }: DonutStatProps) {
  return (
    <div>
      <div className="relative" style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} cx="50%" cy="50%" innerRadius="62%" outerRadius="90%" paddingAngle={3} dataKey="value" stroke="none">
              {data.map((d, index) => (
                <Cell key={`cell-${index}`} fill={d.color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{ backgroundColor: 'oklch(var(--background-50))', border: '1px solid oklch(var(--background-200))', borderRadius: '12px', fontSize: '13px' }}
              formatter={(value: number) => [valueFormatter ? valueFormatter(value) : value, undefined]}
            />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-[11px] text-foreground-400">{totalLabel}</span>
          <span className="text-lg font-bold text-foreground-900 font-heading">{totalValue}</span>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mt-3">
        {data.map((d) => (
          <div key={d.name} className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: d.color }} />
            <span className="text-xs text-foreground-500">{d.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
